import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

// Constants
import { STORAGE_AUTH_TOKEN } from "constants/variables";

// Selectors
import * as authSelectors from "redux/auth/selectors";

// Utils
import { getLocalStorageItem } from "utils/localStorage";

type PrivateRouteProps = {
  children: JSX.Element;
};

const LandingRoute = (props: PrivateRouteProps) => {
  const { children } = props;

  const token = getLocalStorageItem(STORAGE_AUTH_TOKEN);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  return isAuthenticated || token ? (
    <Navigate to={makeLangUrl("/")} />
  ) : (
    children
  );
};

export default LandingRoute;
